module.exports = __webpack_public_path__ + "img/43_21.19923e2f.png";